import PropTypes from 'prop-types';
import { forwardRef, useMemo } from 'react';
import Select from 'Components/Atoms/Select/Select';
import { cn } from 'Utils/cn';
import { useTranslation } from 'react-i18next';
import SelectActionButton from 'Components/Atoms/Select/SelectActionButton';
import OutlineAdd from 'Components/Atoms/OutlineIcons/OutlineAdd';
import useInvoicePaymentMethods from 'Hooks/useInvoicePaymentMethods';
import Skeleton from 'Components/Atoms/Skeleton/Skeleton';

const SelectInvoicePaymentMethod = forwardRef(function SelectInvoicePaymentMethod(props, ref) {
    const { value, disabled, onChange, className, label, error, highlight, onAdd } = props;

    const { paymentMethods, isLoading } = useInvoicePaymentMethods();

    const { t } = useTranslation('invoices');

    const options = useMemo(() => {
        return paymentMethods.map((unit) => ({
            value: unit.id,
            label: unit.name,
        }));
    }, [paymentMethods]);

    const actions = useMemo(() => {
        if (!onAdd) return [];
        return [
            <SelectActionButton
                icon={<OutlineAdd size={18} />}
                key="action-add-invoice-payment-method"
                onClick={() => onAdd()}
            >
                {t('add-new-payment-method')}
            </SelectActionButton>,
        ];
    }, [onAdd, t]);

    if (isLoading) {
        return <Skeleton variant="rectangular" className={cn('w-full', className)} />;
    }

    return (
        <Select
            ref={ref}
            enableClear={!!value}
            onClear={() => onChange(null)}
            disabled={disabled}
            label={label}
            className={cn('w-full', className)}
            options={options}
            onChange={onChange}
            value={value}
            error={error}
            highlight={highlight}
            actions={actions}
        />
    );
});

export default SelectInvoicePaymentMethod;

SelectInvoicePaymentMethod.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
    highlight: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onAdd: PropTypes.func,
};
